import { useSelector } from 'react-redux'

import { isFeatureEnabled } from 'store/college'

const useCollegeFeatures = (featureName) => {
  return useSelector((store) => isFeatureEnabled(store, featureName))
}

export default useCollegeFeatures
